import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getRequestApplicantProfileOptions } from '../../../../../api'
import { useScreen } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { toUserSelectItemsFromOption, UserSelect } from '../../../../User'
import {
  REQUEST_FORM_FIELD_NAME_APPLICANT,
  REQUEST_FORM_FIELD_NAME_BUILDING,
  REQUEST_FORM_FIELD_NAME_FLAT,
} from '../../RequestForm.constants'

import { getBuildingParam } from './ApplicantField.utils'

function ApplicantField({ controlProps }) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const buildingParam = getBuildingParam(
    values[REQUEST_FORM_FIELD_NAME_BUILDING],
    values[REQUEST_FORM_FIELD_NAME_FLAT]
  )

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={UserSelect}
      apiParams={buildingParam}
      controlProps={{
        ...controlProps,
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Request.ApplicantPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Request.ApplicantLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getRequestApplicantProfileOptions}
      getDataItems={getItemsFromIdwellApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      name={REQUEST_FORM_FIELD_NAME_APPLICANT}
      toPreparedItems={toUserSelectItemsFromOption}
    />
  )
}

export default ApplicantField
